<div class="row navbar-row mb-3">
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" routerLink="/search">
      <img height="30"
           src="https://9a812d2609e610ab07eb-b463fa4ca2c8095be4f297e4d7f6781b.ssl.cf2.rackcdn.com/timetap-icon-grey.svg">
    </a>
    <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
      <li class="nav-item">
        <a class="pt-3 px-4 nav-link" routerLink="/account-management" routerLinkActive="active">Account Management</a>
      </li>
      <li class="nav-item">
        <a class="pt-3 px-4 nav-link" routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
      </li>
    </ul>
  </nav>
</div>
